import { render } from "./MenuFoodCard.vue?vue&type=template&id=51f1fbf6&scoped=true"
import script from "./MenuFoodCard.vue?vue&type=script&lang=js"
export * from "./MenuFoodCard.vue?vue&type=script&lang=js"

import "./MenuFoodCard.vue?vue&type=style&index=0&id=51f1fbf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f1fbf6"]])

export default __exports__